// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles */

/* These styles apply to specific pages rather than components or layouts */

/* Home page specific styles */
.home-welcome {
  margin-bottom: 2rem;
}

/* Services page specific styles */
.services-container {
  display: grid;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .services-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .services-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* About page specific styles */
.about-history-timeline {
  position: relative;
  padding-left: 2rem;
  border-left: 2px solid #1a2f4d;
  margin-bottom: 2rem;
}

/* Orthodox resources page specific styles */
.resources-grid {
  display: grid;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .resources-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/index.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,2EAA2E;;AAE3E,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Page-specific styles */\n\n/* These styles apply to specific pages rather than components or layouts */\n\n/* Home page specific styles */\n.home-welcome {\n  margin-bottom: 2rem;\n}\n\n/* Services page specific styles */\n.services-container {\n  display: grid;\n  gap: 1.5rem;\n}\n\n@media (min-width: 768px) {\n  .services-container {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (min-width: 1024px) {\n  .services-container {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* About page specific styles */\n.about-history-timeline {\n  position: relative;\n  padding-left: 2rem;\n  border-left: 2px solid #1a2f4d;\n  margin-bottom: 2rem;\n}\n\n/* Orthodox resources page specific styles */\n.resources-grid {\n  display: grid;\n  gap: 1.5rem;\n}\n\n@media (min-width: 768px) {\n  .resources-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
